import React from "react";
import { Link } from "react-router-dom";

function Logo({ className }) {
  return (
    <Link to="/">
      <div className="logo-wrapper">
        <h5 className={`f-w-700 f-s-20 ${className}`}>ROMA INTEGRATION III</h5>
      </div>
    </Link>
  );
}

export default Logo;
